export default __webpack_public_path__ + "static/media/Arrows&Phone.244c1c9b.png";